export default __webpack_public_path__ + "static/media/blocked.63610e64.png";